import React, { ReactElement } from 'react'
import BasketHireWeeks from './BasketHireWeeks'
import { BasketItemModel } from './types/models'
import { formatNumberString, formatPriceString } from '../../common/helpers/number-formatters'
import ProductImage from './ProductImage'

type BasketItemProps = {
  item: BasketItemModel;
  onItemRemoved: (id: number, discount_id: number) => void;
  onHireWeeksChanged: (id: number, hirePriceId: string) => void;
  includeVat: boolean;
}

const BasketHireItem = ({
  item, onItemRemoved, onHireWeeksChanged, includeVat
}: BasketItemProps): ReactElement => (
  <>
    <hr className="basketDivider" />
    <div className="new-basket-item">
      <div className="basket-item-image basket-item-info">
        {
          item.image &&
            <ProductImage
              title={item.image.title}
              urls={item.image.urls}
            />
        }
      </div>

      <div className="basket-item-details basket-item-info">
        <div className="basket-item-header">
          {
            item.brand &&
              <div className="product-brand">{item.brand}</div>
          }
          <div className="basket-item-product-name">{item.product_name}</div>
          {
            item.feature_descriptions && !item.product.cuttable &&
              <div className="basket-item-feature-descriptions">{item.feature_descriptions}</div>
          }
          <div className="basket-hireSelectContainer">
            <BasketHireWeeks item={item} onHireWeeksChanged={onHireWeeksChanged} />
          </div>
        </div>

        <div className="basket-item-footer">
          <button className="basket-item-remove-button" onClick={(): void => onItemRemoved(item.id, item.discount_id)}>Remove</button>
        </div>
      </div>

      <div className="basket-item-weight basket-item-info basket-item-single-line">
        <span className="mobile-only">Weight:&nbsp;</span>
        <span className="v-center">{formatNumberString(item.weight, 2)}&nbsp;kg</span>
      </div>

      <div className="basket-item-unit-price basket-item-info basket-item-single-line">
        <span className="mobile-only">First 4 weeks hire:&nbsp;</span>
        <span className="v-center">{ formatPriceString(item.initial_hire_price_inc_vat) }</span>
      </div>

      <div className="basket-item-installation basket-item-info basket-item-single-line">
        <span className="mobile-only">Installation:&nbsp;</span>
        <span className="v-center">
          {formatPriceString(item.installation_charge_inc_vat)}
        </span>
      </div>

      <div className="basket-item-total basket-item-info basket-item-single-line">
        <span className="mobile-only">Total:&nbsp;</span>
        <span className="v-center">
          {formatPriceString(includeVat ? item.line_total_inc_tax : item.line_total_ex_tax)}
        </span>
      </div>
    </div>
  </>
)

export default BasketHireItem
